export const meta = {
  title: 'சிக்கல் தீர்வு: ஏதோ சரியில்லை எனத் தோன்றும்போது',
  updatedAt: '2026-07-17',
  related: ['faq', 'notifications', 'billing'],
};

ஆபரேட்டர்கள் அடிக்கடி சந்திக்கும் நான்கு விஷயங்கள் — முதலில் அறிகுறி, பிறகு எதைச் சரிபார்க்க வேண்டும் என்பது துல்லியமாக.

## வாடிக்கையாளரால் ஆப்பை நிறுவ முடியவில்லை

- **Android (Chrome)** — உலாவி அனுமதிக்கும்போது உங்கள் ஆப்பினுள் **நிறுவு** பொத்தான் தோன்றும். வாடிக்கையாளர் உலாவியின் சொந்தத் தூண்டலை நிராகரித்திருந்தால், அதே அமர்வில் Chrome மீண்டும் வழங்காது — உலாவியை மூடித் திறந்தால் பொத்தான் திரும்பும்.
- **iPhone (Safari)** — Apple நிறுவல் தூண்டலைக் காட்டுவதே இல்லை. உங்கள் ஆப் இதைக் கண்டறிந்து மூன்று கைமுறை படிகளைக் காட்டும்: **பகிர்** மெனுவைத் திறங்கள், **முகப்புத் திரையில் சேர்** என்பதைத் தேர்ந்தெடுங்கள், உறுதிப்படுத்துங்கள்.
- எப்படியிருந்தாலும் நிறுவல் விருப்பம்தான். முன்பதிவு, நேரலை வரிசை நிலை, கட்டணம் — அனைத்தும் சாதாரண உலாவித் தாவலில் இயங்கும்.

## அறிவிப்புகள் வரவில்லை

இந்தப் பட்டியலின் வழியே இறங்குங்கள்:

1. **அனுமதி** — ஆப் கேட்டபோது (முன்பதிவுக்குப் பின் உடனே கேட்கும்) வாடிக்கையாளர் அனுமதித்திருக்க வேண்டும். தடு என்று தட்டியிருந்தால் உலாவி நினைவில் வைக்கும்: உங்கள் தளத்திற்கான உலாவி அமைப்புகளில் அவர்கள் மீண்டும் அனுமதிக்க வேண்டும் — ஆப் தானாக மறுபடி கேட்க முடியாது.
2. **iPhone** — ஆப்பை முகப்புத் திரையில் சேர்த்த பிறகுதான் அறிவிப்புகள் இயங்கும்; சாதாரண Safari தாவலுக்கு புஷ் வராது.
3. **எதிர்பார்ப்புகள்** — டிக்கெட் வரிசையில் சேரும்போது, கழுவல் தொடங்கும்போது, தயார் ஆகும்போது, ரத்தாகும்போது, இடைநிறுத்தப்படும்போது மட்டுமே புஷ் செல்லும் — கூடுதலாக நிலை-உயர்வு வாழ்த்து. **எடுத்துச்செல்லும்போது புஷ் இல்லை** — "ரசீது" அறிவிப்பு காணாமல் போகவில்லை; அது இருக்கவே இல்லை.
4. **மார்க்கெட்டிங் குறிப்பாக** — விலகல்களும் அமைதி நேரமும் (இயல்பாக 22:00–08:00) மார்க்கெட்டிங் புஷ்களை அமைதியாகவும் சரியாகவும் விழுங்கும். எத்தனை தவிர்க்கப்பட்டன, ஏன் — உங்கள் அனுப்புதல் சுருக்கம் துல்லியமாகச் சொல்லும்.

## கட்டண இணைப்பு காலாவதியானது

இரு வேறு நிலைகள்:

- **வாடிக்கையாளர் கழுவலுக்கு ஆன்லைனில் பணம் செலுத்துகிறார்** — கட்டணப் பக்கங்கள் வடிவமைப்பிலேயே ஒருமுறை-பயன், குறுகிய-ஆயுள் கொண்டவை. தீர்வு எளிது: **செலுத்து** என்பதை மீண்டும் தட்டுங்கள் — ஒவ்வொரு தட்டலும் புத்தம்புதிய இணைப்பை வழங்கும். கைவிடப்பட்ட முயற்சிகள் தாமாகக் காலாவதியாகும்; யாரிடமும் பணம் பிடிக்கப்படாது.
- **உங்கள் சொந்த சந்தா இன்வாய்ஸ்** — பில்லிங் பக்கத்தில், இன்வாய்ஸுக்கு அருகிலுள்ள **மீண்டும் உருவாக்கு** மூலம் புதிய கட்டண இணைப்பைப் பெறுங்கள். புதிய இணைப்பு மட்டுமே இன்வாய்ஸை முடிக்க முடியும்; இரட்டைக் கட்டண அபாயத்தைத் தவிர்க்க பழையவை நிராகரிக்கப்படும்.

## என் கடை பொது அடைவில் தெரியவில்லை

இந்த வரிசையில் சரிபார்க்கவும்:

1. **நிலைமாற்றி** — நேரங்கள் பக்கத்தின் அடியிலுள்ள _என் கடைகளைப் பொது அடைவில் காட்டு_ இயக்கப்பட்டிருக்க வேண்டும். ஒவ்வொரு புதிய கணக்கிலும் அது இயல்பாக அணைந்துள்ளது.
2. **கடை நிலை** — செயலிலுள்ள கடைகள் மட்டுமே பட்டியலிடப்படும். நீங்கள் மூடிய அல்லது நீக்கிய கடை தானாக அடைவிலிருந்து விலகும்.
3. **நேரம்** — சேமித்த சில நொடிகளில் மாற்றங்கள் பாயும். தடங்கல் சந்தேகித்தால் நிலைமாற்றியை அணைத்து மீண்டும் இயக்கி புதுப்பிப்பை வலியுறுத்துங்கள்.
4. **கண்காணிப்பு** — நெட்வொர்க் பொது அடைவை மேற்பார்வை செய்கிறது; விதிகளை மீறும் பட்டியலை மறைக்கக்கூடும். தவறுதலாக மறைக்கப்பட்டதாக நினைத்தால், தொடர்பு பக்கத்தின் வழி எங்களுக்கு எழுதுங்கள்.

## இன்னும் சிக்கலா?

**தொடர்பு** பக்கம் ஒரு வேலை நாளுக்குள் ஒரு மனிதரைச் சென்றடையும் — அடிக்குறிப்பிலுள்ள WhatsApp இன்னும் வேகம். நீங்கள் பார்த்ததையும் எதிர்பார்த்ததையும் சொல்லுங்கள்; திரைப்பிடிப்புகள் உதவும்.
